import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../auth/useAuth';
import './CheckinLayout.css';
import { ImpersonationBanner } from './ImpersonationBanner';

/**
 * Shell for the check-in PWA.
 *
 * Deliberately not the portal chrome: this is used one-handed, at a door, often
 * in the dark and on a phone. It gets a full-bleed dark surface, oversized
 * touch targets, and no sidebar competing for thumb space.
 */
export function CheckinLayout() {
  const { user, logout } = useAuth();

  return (
    <div className="checkin-layout">
      <ImpersonationBanner />
      <header className="checkin-header">
        <Link to="/checkin" className="checkin-header__brand display">
          Voleto Check-in
        </Link>
        <div className="checkin-header__account">
          <span className="identifier">{user?.role}</span>
          <button type="button" className="button button--ghost" onClick={() => void logout()}>
            Sign out
          </button>
        </div>
      </header>

      <main className="checkin-main">
        <Outlet />
      </main>
    </div>
  );
}
